export const withAttribs = (shape, attribs, replace = true) => {
    shape.attribs = replace ? attribs : Object.assign(Object.assign({}, shape.attribs), attribs);
    return shape;
};
